<script lang="ts" setup>
import LearningMenu from '../components/learning/LearningMenu.vue';
import LearningList from '../components/learning/LearningList.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <LearningMenu />
  <LearningList v-if="route.path === '/learning'" />
</template>
